module.exports = __webpack_public_path__ + "img/ibms_sold_out_p@2x.cc510d41.png";